import { render, staticRenderFns } from "./widget-settings.vue?vue&type=template&id=7a35ed54&"
import script from "./widget-settings.vue?vue&type=script&lang=js&"
export * from "./widget-settings.vue?vue&type=script&lang=js&"
import style0 from "./widget-settings.vue?vue&type=style&index=0&id=7a35ed54&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports